<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <a href="https://www.ijzzn.com">
        <img src="@/assets/img/foot-logo.png" alt="JianZhi Intelligence Logo">
      </a>

    </div>
    <p class="title">郑州渐知智能科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：河南自贸试验区郑州片区（郑东）楷林IFC-B座</span>
      <span>Tel：13253536393</span>
    </p>
    <p class="email_wx">
      <span>邮箱：jzzn@ijzzn.com</span>
    </p>
<!--    <p class="email_wx">-->
<!--      <span>哔哩哔哩：bilibio.com</span>-->
<!--    </p>-->
    <p class="copy">
      <span>
        <a href="https://beian.miit.gov.cn" target="_blank">豫ICP备2024079144号-1</a>&nbsp;
      <span>
          <a href="https://beian.mps.gov.cn/#/query/websearch?code=41010502006085" rel="noreferrer" target="_blank">
          <img style="display: inline" src="../../static/plo.png" height="14" width="14"/>豫公网安备41010502006085</a >
      </span>
      <span>
          增值电信业务经营许可：<a href="https://dxzhgl.miit.gov.cn" target="_blank">豫B2-20250683</a>&nbsp;
<!--          <img style="display: inline" src="../../static/plo.png" height="14" width="14"/>豫公网安备41010502006085</a >-->
      </span>

      </span>
    </p>
    <p>

    </p>
    <p class="copy">Copyright &copy; 2023 - {{ new Date().getFullYear() }} 渐知智能  版权所有 </p>

  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>

#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #e5eef8;
  overflow: hidden;
  text-align: center;
}
.logo {
  text-align:  left;
  width: 260px;
  height: 64px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
  color: #4e4c4c;
}
.address_tel_fax {
  color: #4e4c4c;
  font-size: 14px;
  /*margin: 10px 0;*/
}
.email_wx {
  color: #4e4c4c;
  font-size: 14px;
}
.copy {
  color: #4e4c4c;
  font-size: 14px;
  /*margin: 0px 0 10px;*/
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue